<template>
  <transition name="fade">
    <div
      id="google-signin-button"
      ref="googleSigninButton"
      :class="{
        disabled: disabled
      }"
    ></div>
  </transition>
</template>
<script>
import env from '@/env'
import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    label: {
      type: String,
      default: 'Sign in with Google'
    }
  },
  data: function() {
    return {
      show: false,
      disabled: false
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alert/addAlert'
    }),

    ...mapMutations({
      clearGoogleToken: 'auth/clearGoogleToken'
    }),

    onSuccess(googleUser) {
      let token = googleUser.getAuthResponse().id_token
      this.$emit('on-success', { token, provider: 'google' })
    },
    onFailure(error) {
      this.clearGoogleToken()
      return error
    },

    customButtonStyle() {
      if (!this.$refs.googleSigninButton) return

      let button = this.$refs.googleSigninButton.getElementsByClassName(
        'abcRioButtonContents'
      )[0]

      if (button) {
        button.innerHTML = this.label
      }
    },

    loadGoogleButton() {
      return new Promise((resolve, reject) => {
        window.gapi.signin2.render(this.$el, {
          scope: 'profile email',
          width: 'auto',
          height: 35,
          longtitle: true,
          theme: 'light',
          onsuccess: this.onSuccess,
          onfailure: this.onFailure
        })

        window.onload = () => {
          resolve()
        }

        window.onerror = error => {
          reject(error)
        }
      })
    },
    loadGoogleScript() {
      return new Promise((resolve, reject) => {
        let meta = document.createElement('meta')
        meta.setAttribute('name', 'google-signin-client_id')
        meta.setAttribute('content', env.googleSigninClientId)
        document.head.appendChild(meta)

        let script = document.createElement('script')
        script.setAttribute('src', 'https://apis.google.com/js/platform.js')
        script.async = true
        document.head.appendChild(script)

        script.onload = () => {
          resolve()
        }

        script.onerror = error => {
          reject(error)
        }
      })
    },

    handleError(error) {
      this.disabled = true

      /* eslint handle-callback-err: "warn" */
      this.addAlert({
        state: false,
        label:
          'Google sign-in failed to load, this may be caused by 3rd party cookies being disabled by your browser'
      })
    }
  },
  mounted() {
    this.loadGoogleScript()
      .then(() => {
        this.loadGoogleButton()
          .then(() => {
            this.customButtonStyle()
          })
          .catch(error => {
            this.handleError(error)
          })
        this.customButtonStyle()
      })
      .catch(error => {
        this.handleError(error)
      })
  }
}
</script>
